import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useRef, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation, useFocusEffect } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import CloseIcon from '@mui/icons-material/Close';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { IoTriangleOutline } from "react-icons/io5";
import { GrEmptyCircle } from "react-icons/gr";
import axios from 'axios';
import { ProductContext } from '../context/AppContext';
import { FaStopCircle, FaPlayCircle } from "react-icons/fa";
import Footer from './Common_Components/Footer';
function TakeQuiz() {


    // const [currentQuestion, setCurrentQuestion] = useState(0);
    const location = useLocation();
    // const navigate = useNavigate();
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    const [selectedOption, setSelectedOption] = useState(null);
    const [isCorrect, setIsCorrect] = useState(null);
    const [timer, setTimer] = useState(0); // Start timer from 0
    const [activePage, setActivePage] = useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true); // Disable submit initially
    const navigate = useNavigate();
    const [showResultButtons, setShowResultButtons] = useState(false); // Control when to show the new buttons
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null); // Track whether the answer is correct
    const [explanation, setExplanation] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [quizData, setQuizData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { Translate } = useContext(ProductContext);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeSpent, setTimeSpent] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showSubmitMessage, setShowSubmitMessage] = useState(false);
    const [attemptStatus, setAttemptStatus] = useState(null);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const [attemptstatus22, setAttemptStatus22] = useState();
    const [attemptedQuestions, setAttemptedQuestions] = useState(0);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [language, setLanguage] = useState('english');
    const [text, setText] = useState({});
    const swingAnimRef = useRef();
    const authToken = localStorage.getItem("AuthToken");
    const [isExplanationVisible, setIsExplanationVisible] = useState(false);
    const screenTitleId = location.state?.screenTitleId;

    const [loading, setLoading] = useState(false);
    const unAttemptCountRef = useRef(0);
    const [submittedQuestions, setSubmittedQuestions] = useState(new Set());
    const currentAudioRef = useRef(null);
    const [currentAudio, setCurrentAudio] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const {
        skippedCount,
        setSkippedCount,
        correctCount,
        setCorrectCount,
        incorrectCount,
        setIncorrectCount,
        resetQuizData,
    } = useContext(ProductContext);

    const { categoryId, dayId, unique_day_id, LearningId, categoryName, total_time_spent, quizName, methodType, examTypes, examId } = location.state || {};
    const resolvedUniqueDayId = unique_day_id || dayId;

    const completeQuizAndGoToRoadmap = async () => {
        try {
            const token = localStorage.getItem("AuthToken");
            const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
            const examIdVal = examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
            if (token && categoryId && LearningId && screenTitleId && examIdVal && resolvedUniqueDayId) {
                await fetch(`${baseUrl}/api/user-visits/finish-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: resolvedUniqueDayId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId: examIdVal,
                    }),
                });
            }
        } catch (error) {
            console.error("Error calling finish-visit in TakeQuiz:", error);
        }

        const examIdVal = examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
        navigate("/new-learning-journey", {
            state: {
                selectedExamId: examIdVal,
                examId: examIdVal,
                examTypes: examTypes || [],
            },
        });
    };

    const [isAiModalOpen, setIsAiModalOpen] = useState(false);
    const [aiLanguage, setAiLanguage] = useState("english"); // 'english' or 'hindi'
    const [aiDisplayedText, setAiDisplayedText] = useState("");
    console.log(
        'this is examTypes take quiz',examTypes
    );
    useEffect(() => {
        const postVisit = async () => {
            if (!categoryId || !LearningId || !screenTitleId || !resolvedUniqueDayId) {
                return;
            }

            try {
                const token = localStorage.getItem("AuthToken");
                if (!token) {
                    return;
                }

                const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
                const response = await fetch(`https://api.japaking.online/api/user-visits/log-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: dayId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId: location.state?.examId,
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
            } catch (error) {
                console.log("Error posting quiz visit:", error);
            }
        };

        postVisit();
    }, [categoryId, LearningId, screenTitleId, dayId, resolvedUniqueDayId, location.state?.examId]);
    useEffect(() => {
        const postTimeSpent = async () => {
            const total_time_spent_ms = total_time_spent * 1000;
            const timerData = {
                level_id: dayId,
                category_id: categoryId,
                total_time_spent: total_time_spent_ms,
            };
            console.log('this is timeer data ', timerData);
            try {
                const response = await axios.post(
                    `https://api.japaking.online/api/userQuizTime`,
                    timerData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );


                console.log('Time spent data submitted successfully:', response.data);
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    console.log('navigate to login due to 401');
                    navigate('Login');
                }
                console.log('Error submitting time spent data:', err);
            }
        };

        postTimeSpent();
    }, [total_time_spent, categoryId, dayId]);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    // const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    useEffect(() => {
        setAttemptStatus22(undefined);
        setSelectedOption(null);
        setCurrentQuestionIndex(0);
        setQuizData([]);
        setAttemptedQuestions(0);
        setIsOptionSelected(false);
        setShowSubmitMessage(false);
        fetchQuizData(currentPage);

        // Cleanup function (if necessary)
        return () => {
            // Clean up any resources if needed
        };
    }, [currentPage]);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeSpent(prevTime => prevTime + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // Use location.state and currentPage as dependencies


    useEffect(() => {
        const loadNextSet = false; // Replace with actual condition or logic to determine loadNextSet.

        if (loadNextSet) {
            resetQuizData();
            setAttemptStatus22(undefined);
            setCurrentPage(prevPage => prevPage + 1);
            setCurrentQuestionIndex(0);
            setQuizData([]);
            fetchQuizData(currentPage + 1);
        } else {
            fetchQuizData(currentPage);
        }
    }, [currentPage]); // Add necessary dependencies to the dependency array.

    const fetchQuizData = async page => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `https://api.japaking.online/api/categories/question/day?categoryId=${categoryId}&dayId=${dayId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.data.success) {
                const newQuestions = response.data.message.category
                setQuizData(newQuestions);

            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                // console.log('navigate to login due to 401');
                navigate('Login');
            }
            console.log('Error submitting user attempt:', err);
        } finally {
            setIsLoading(false);
            setIsLoadingImage(false);
        }
    };
    const playAudio = (audioUrl, setAudioState, setIsPlayingState) => {
        stopAudio(); // Stop any currently playing audio

        const audio = new Audio(audioUrl); // Create new audio instance
        audio.play()
            .then(() => {
                setAudioState(audio); // Set the current audio instance
                setIsPlayingState(true); // Update playing state
            })
            .catch((error) => {
                console.error('Error during audio playback:', error);
                setIsPlayingState(false); // Reset playing state on error
            });

        audio.addEventListener('ended', () => {
            setIsPlayingState(false); // Reset playing state when audio ends
        });

        currentAudioRef.current = audio; // Store the current audio instance
    };

    const stopAudio = () => {
        if (currentAudioRef.current) {
            currentAudioRef.current.pause(); // Pause the current audio
            currentAudioRef.current.currentTime = 0; // Reset playback position
            currentAudioRef.current = null; // Clear the reference
        }
        setIsPlaying(false); // Update playing state
    };

    const toggleSound = (
        audioUrl,
        currentAudio,
        setAudioState,
        isPlayingState,
        setIsPlayingState
    ) => {
        if (isPlayingState) {
            stopAudio(); // Stop audio if it's currently playing
        } else {
            if (currentAudio && currentAudio.src === audioUrl) {
                currentAudio
                    .play()
                    .then(() => setIsPlayingState(true))
                    .catch((error) => {
                        console.error('Error resuming audio playback:', error);
                        setIsPlayingState(false);
                    });
            } else {
                playAudio(audioUrl, setAudioState, setIsPlayingState); // Play new audio
            }
        }
    };

    const speakText = (text, lang) => {
        if (!text) {
            return;
        }
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = lang;
            window.speechSynthesis.speak(utterance);
        } else {
            alert("Speech Synthesis not supported in your browser.");
        }
    };

    const isJapaneseChar = (char) => {
        const code = char.charCodeAt(0);
        // Hiragana, Katakana, CJK Unified Ideographs (Kanji)
        return (
            (code >= 0x3040 && code <= 0x309F) || // Hiragana
            (code >= 0x30A0 && code <= 0x30FF) || // Katakana
            (code >= 0x4E00 && code <= 0x9FFF)    // Kanji
        );
    };

    const speakHindiExplainWithJapanese = (text) => {
        if (!text) return;
        if (!("speechSynthesis" in window)) {
            alert("Speech Synthesis not supported in your browser.");
            return;
        }

        const segments = [];
        let current = "";
        let currentLang = null;

        for (let i = 0; i < text.length; i += 1) {
            const ch = text[i];
            const isJa = isJapaneseChar(ch);
            const langForChar = isJa ? "ja-JP" : "hi-IN";

            if (currentLang === null) {
                currentLang = langForChar;
                current = ch;
            } else if (langForChar === currentLang) {
                current += ch;
            } else {
                segments.push({ text: current, lang: currentLang });
                currentLang = langForChar;
                current = ch;
            }
        }

        if (current) {
            segments.push({ text: current, lang: currentLang });
        }

        if (segments.length === 0) {
            return;
        }

        window.speechSynthesis.cancel();
        segments.forEach((segment) => {
            const utterance = new SpeechSynthesisUtterance(segment.text);
            utterance.lang = segment.lang;
            window.speechSynthesis.speak(utterance);
        });
    };

    const renderWithBold = (text) => {
        if (!text) return null;
        const parts = text.split("**");
        return parts.map((part, index) =>
            index % 2 === 1 ? <strong key={index}>{part}</strong> : part
        );
    };

    const handlePlayPause = (
        audioUrl,
        setAudioState,
        isPlayingState,
        setIsPlayingState
    ) => {
        if (
            currentAudioRef.current &&
            currentAudioRef.current.src === audioUrl
        ) {
            toggleSound(
                audioUrl,
                currentAudioRef.current,
                setAudioState,
                isPlayingState,
                setIsPlayingState
            );
        } else {
            playAudio(audioUrl, setAudioState, setIsPlayingState);
        }
    };

    // Cleanup on component unmount
    useEffect(() => {
        return () => {
            stopAudio(); // Stop audio when the component unmounts
        };
    }, []);



    // const formatTime = (timeInSeconds) => {
    //     const minutes = Math.floor(timeInSeconds / 60);
    //     const seconds = timeInSeconds % 60;
    //     return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    // };
    const handleSelect = (optionId) => {
        setSelectedOption(optionId); // Update selected option
        setIsSubmitDisabled(false); // Enable submit button
        setShowSelectAnswerMessage(false); // Hide the "select an answer" message
    };
    const handleOptionClick = (index) => {
        setSelectedOption(index); // Set the selected option
        setIsSubmitDisabled(false); // Enable the submit button
    };
    const submitUserAttempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        if (submittedQuestions.has(currentQuestion.question_id)) {
            return;
        }
        setSubmittedQuestions(prev =>
            new Set(prev).add(currentQuestion.question_id),
        );
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );

        const attemptStatus = selectedOption
            ? selectedOptionData?.is_correct
                ? 'correct'
                : selectedOptionData?.is_correct
                    ? 'confirm'
                    : selectedOptionData?.is_correct
                        ? 're_attempt'
                        : 'incorrect'
            : 'un_attempt';

        if (attemptStatus === 'correct' || attemptStatus === 'confirm' || attemptStatus === 're_attempt') {
            setCorrectCount(prev => prev + 1);
        } else if (attemptStatus === 'incorrect') {
            setIncorrectCount(prev => prev + 1);
        } else if (attemptStatus === 'skipped' || attemptStatus === 'un_attempt') {
            setSkippedCount(prev => prev + 1);
        }

        const userAttemptData = {
            questionId: currentQuestion.question_id,
            optionId: selectedOption || null,
            attemptStatus,
        };

    };

    const [showSelectAnswerMessage, setShowSelectAnswerMessage] = useState(false);

    // const handleSubmitAnswer = async () => {
    //     if (!selectedOption) {
    //         setShowSelectAnswerMessage(true);
    //         return;
    //     }
    const handleSubmit = async () => {
        if (!selectedOption) {
            setShowSelectAnswerMessage(true); // Show message if no option is selected
            return;
        }
        // Proceed with submission logic
        await submitUserAttempt();
        setAttemptedQuestions(attemptedQuestions + 1);
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption
        );

        // Determine if the answer is correct
        const answerCorrect = selectedOptionData?.is_correct || false;
        setIsCorrect(answerCorrect);
        setShowResultButtons(true); // Show the result buttons
        setIsSubmitted(true);
    };


    const navigateToResults = () => {
        const examIdVal = examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
        navigate('/results', {
            state: {
                categoryId,
                dayId,
                categoryName,
                LearningId,
                total_time_spent: timeSpent,
                correctCount,
                incorrectCount,
                skippedCount,
                length: quizData?.length,
                methodType,
                examTypes,
                examId: examIdVal,
                selectedExamId: examIdVal,
                screenTitleId,
                unique_day_id: resolvedUniqueDayId
            }
        });
    };

    const handleNextQuestion = () => {
        const isLastQuestion = currentQuestionIndex === quizData.length - 1 && !hasMoreQuestions;

        if (isLastQuestion) {
            navigateToResults();
        } else {
            // Move to the next question or next page if more questions are available
            if (currentQuestionIndex < quizData.length - 1) {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
            } else if (hasMoreQuestions) {
                setCurrentPage(nextPage => nextPage + 1);
                setCurrentQuestionIndex(currentQuestionIndex + 1);
            }

            // Reset states for the next question
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        }
    };
    const currentQuestion = quizData[currentQuestionIndex];
    const progress22 = `${currentQuestionIndex + 1}/${quizData.length}`;
    const progressPercentage = ((currentQuestionIndex + 1) / quizData.length) * 100;
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    useEffect(() => {
        if (!isAiModalOpen) {
            setAiDisplayedText("");
            return;
        }

        if (!currentQuestion) {
            setAiDisplayedText("");
            return;
        }

        const fullText =
            aiLanguage === "english"
                ? currentQuestion.ai_english_explain
                : currentQuestion.ai_hindi_explain;

        if (!fullText) {
            setAiDisplayedText("");
            return;
        }

        setAiDisplayedText("");
        let index = 0;
        const intervalId = setInterval(() => {
            index += 1;
            setAiDisplayedText(fullText.slice(0, index));
            if (index >= fullText.length) {
                clearInterval(intervalId);
            }
        }, 5);

        return () => clearInterval(intervalId);
    }, [isAiModalOpen, aiLanguage, currentQuestion]);

    const openAiModal = () => {
        if (!currentQuestion) return;
        if (!currentQuestion.ai_english_explain && !currentQuestion.ai_hindi_explain) return;
        setAiLanguage(currentQuestion.ai_english_explain ? "english" : "hindi");
        setIsAiModalOpen(true);
    };

    const closeAiModal = () => {
        setIsAiModalOpen(false);
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
        }
    };

    // const progressWidth = ((currentQuestion + 1) / questions.length) * 100;
    const handleMoveToQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            navigate('/take-quiz', {
                categoryId: categoryId,
            });

        } else {

            navigate('thank-you-quiz', {
                categoryId,
                    dayId,
                    categoryName,
                    LearningId,
                    total_time_spent: timeSpent,
                    correctCount,
                    incorrectCount,
                    skippedCount,
                    length: quizData?.length,
                    methodType,
                    examTypes
            });
        }
        setShowSubmitMessage(false);
    };
    const handleStartNewQuiz = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        if (currentQuestionIndex + 1 === quizData.length) {
            navigateToResults();
        } else if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else if (hasMoreQuestions) {
            setCurrentPage(nextPage => nextPage + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else {
            navigateToResults();
        }
    };


    const handleSkip = async () => {
        const currentQuestion = quizData[currentQuestionIndex];

        const userAttemptData = {
            questionId: currentQuestion.question_id,
            attemptStatus: 'un_attempt',
        };

        setSkippedCount(prev => {
            const updatedCount = prev + 1;
            return updatedCount;
        });

        try {
            setLoading(true);
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log('Navigate to login due to 401');
                navigate('/');
            }
            console.log('Error submitting user attempt in handleSkip:', err);
        } finally {
            setLoading(false);
        }
        window.scrollTo({
            top: 0,      // Scroll to the top
            behavior: 'smooth', // Smooth scrolling animation
        });
        const updatedSkippedCount = skippedCount + 1;

        if (currentQuestionIndex + 1 === quizData.length) {
            navigateToResults();
        } else {
            handleNextQuestion();
        }
    };

    const handleSureMove = async () => {
        const currentQuestion = quizData[currentQuestionIndex];



        const userAttemptData = {
            questionId: currentQuestion.question_id,

            attemptStatus: 'confirm',
        };

        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );


            const attemptStatus = response.data.message.attempt.attempt_status;
            setAttemptStatus(attemptStatus);
            setAttemptStatus22(response?.data?.message);

        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log('Navigate to login due to 401');
                navigate('Home');
            }
            console.log('Error submitting user attempt:', err);
        }

        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else {
            console.log('i am here in else ');
            navigateToResults();
        }
    };

    const handeReattempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,

            attemptStatus: 're_attempt',
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/user-attempt-day`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
            setShowResultButtons(false);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }

        handleNextQuestion();

    };

    useEffect(() => {
        if (!isLoading && quizData.length === 0) {

            navigate("/coming-soon");
        }
    }, [isLoading, currentQuestion, navigate]);

    useEffect(() => {
        if (currentQuestion?.options?.[0]?.option_description) {
            setIsExplanationVisible(true);
        } else {
            setIsExplanationVisible(false);
        }
    }, [currentQuestion]);
    const progressWidth = ((currentQuestion + 1) / quizData.length) * 100;
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    if (isLoadingImage) {

    }
    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                             <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey')} className='icon_1' />
                            <h2>
                                {showResultButtons
                                    ? Translate?.message?.data?.quizResult || "Quiz Result"
                                    : Translate?.message?.data?.quiz || "Quiz"}
                            </h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container JLPT_Quiz" style={{ marginTop: "75px", marginBottom: "75px", height: "auto" }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            {isLoadingImage ? (
                                <div className="quiz-loading">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                        alt="Loading..."
                                        className="lecture-video-placeholder"
                                    />
                                </div>
                            ) : (
                                <div
                                    className={`quiz-container ${isSubmitted ? "left" : ""}`}

                                >

                                    <div className="quiz-header">
                                        <div className="quiz-info">
                                            <span>{currentQuestionIndex + 1}/{quizData.length}</span>
                                        </div>
                                        <div className="quiz-timer">
                                            <span>{formatTime(timeSpent)}</span>
                                        </div>
                                    </div>
                                    <div className="progress-bar-container" style={{ backgroundColor: 'gray', height: '10px', borderRadius: '5px' }}>
                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${progressPercentage}%`,
                                                backgroundColor: '#ffc0cb',
                                                height: '100%',
                                                borderRadius: '5px',
                                            }}
                                        ></div>
                                    </div>

                                    <div className="quiz-question">
                                        <div className="quiz-header">
                                            <h6>{Translate?.message?.data?.selectTheCorrectTranslation || "Select the correct translation"}</h6>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                {currentQuestion && (currentQuestion.ai_english_explain || currentQuestion.ai_hindi_explain) && (
                                                    <button
                                                        className="quiz-help-ai-button"
                                                        onClick={openAiModal}
                                                    >
                                                        Help AI
                                                    </button>
                                                )}
                                                {currentQuestion && currentQuestion.audio_url && (
                                                    <div
                                                        className="video_icon_quiz"
                                                        onClick={() =>
                                                            handlePlayPause(
                                                                currentQuestion.audio_url,
                                                                setCurrentAudio,
                                                                isPlaying,
                                                                setIsPlaying
                                                            )
                                                        }
                                                    >
                                                        {isPlaying && currentAudioRef.current?.src === currentQuestion.audio_url ? (
                                                            <FaStopCircle size={30} />
                                                        ) : (
                                                            <FaPlayCircle size={30} />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="quiz-question-container">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/assets/images/question15.png`}
                                                alt="icon"
                                                className="question-icon"
                                            />
                                            <div className="quiz-question-box">
                                                <h7>{currentQuestion?.question_text || "Question not available"}</h7>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="quiz-options-container">
                                        <div className="quiz-options">
                                            {currentQuestion?.options?.length > 0 ? (
                                                currentQuestion.options.map((option) => (
                                                    <button
                                                        key={option.option_id}
                                                        className={`quiz-option ${selectedOption === option.option_id
                                                                ? isSubmitted && isCorrect === true
                                                                    ? 'correct'
                                                                    : isSubmitted && isCorrect === false
                                                                        ? 'incorrect'
                                                                        : 'selected'
                                                                : ''
                                                            }`}
                                                        onClick={() => handleSelect(option.option_id)}
                                                        disabled={isSubmitted} // Only disable after submission
                                                    >
                                                        <span
                                                            className={`quiz-option-text ${selectedOption === option.option_id
                                                                ? 'selected-text' // Apply selected-text class if the option is selected
                                                                : ''
                                                                }`}
                                                        >
                                                            {option.option_text || 'Option'} {/* Fallback text for option */}
                                                        </span>

                                                        {/* Feedback messages displayed only after submission */}
                                                        {isSubmitted && selectedOption === option.option_id && isCorrect === false && (
                                                            <span className="responsive-incorrect">
                                                                <CloseIcon className="quiz-close-icon" />
                                                                {Translate?.message?.data?.incorrect || "Incorrect"}
                                                            </span>
                                                        )}

                                                        {isSubmitted && selectedOption === option.option_id && isCorrect === true && (
                                                            <span className="responsive-correct">
                                                                <RadioButtonUncheckedIcon
                                                                    className="quiz-checked-icon"
                                                                />
                                                                {Translate?.message?.data?.correct || "Correct"}
                                                            </span>
                                                        )}
                                                    </button>
                                                ))
                                            ) : (
                                                <p>Loading...</p> // Fallback UI for no options
                                            )}
                                            {showSelectAnswerMessage && (
                                                <h7 style={{
                                                    color: 'red',
                                                    marginTop: 5,
                                                    textAlign: 'left', // Align the text to the right
                                                }}>
                                                    {Translate?.message?.data?.pleaseSelectAnAnswer || " Please select an answer."}
                                                </h7>
                                            )}
                                        </div>
                                    </div>
                                    <div className="quiz-controls">
                                        <div className="quiz-buttons">
                                            {showResultButtons ? (
                                                isCorrect ? (
                                                    <>
                                                        {/* Explanation Box */}
                                                        <div className="quiz-content">
                                                            <div className={`explanation-box ${!currentQuestion?.options?.[0]?.option_description ? 'hidden' : ''}`}>
                                                                {currentQuestion?.options?.[0]?.option_description && (
                                                                    <>
                                                                        <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>
                                                                        {currentQuestion?.options?.map((option, i) => (
                                                                            <div key={i} className="explanation-item">
                                                                                <span>{option?.option_description}</span>
                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                )}
                                                            </div>


                                                            {/* Buttons for Correct Answer */}
                                                            <div
                                                                className={`result-buttons-correct ${!currentQuestion?.options?.[0]?.option_description ? 'no-explanation' : ''
                                                                    }`}
                                                            >
                                                                <button className="quiz-submit" onClick={handeReattempt}>
                                                                    {Translate?.message?.data?.wantToReattempt || "Want to Reattempt"}
                                                                    <div className="want-reattempt-icon">
                                                                        <IoTriangleOutline size={20} color="white" />
                                                                    </div>
                                                                </button>

                                                                <button className="quiz-submit" onClick={handleStartNewQuiz}>
                                                                    {Translate?.message?.data?.next || "Next"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {/* Explanation Box */}
                                                        {currentQuestion?.options?.[0]?.option_description && (
                                                            <div className="explanation-incorect-box">
                                                                <>
                                                                    <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>
                                                                </>
                                                                {currentQuestion?.options?.map((option, i) => (
                                                                    <div key={i} className="explanation-item">
                                                                        <span>{option?.option_description}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* Buttons for Incorrect Answer */}
                                                        <div className="result-buttons-incorrect">
                                                            <button className="quiz-submit" onClick={handleStartNewQuiz}>
                                                                {Translate?.message?.data?.next || "Next"}
                                                            </button>
                                                        </div>
                                                    </>
                                                )
                                            ) : (
                                                <>
                                                    {/* Initial Buttons */}
                                                    <div>
                                                        {loading ? (
                                                            // Show a loading state for the button
                                                            <button
                                                                className="quiz-submit"
                                                                style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                                disabled
                                                            >
                                                                {Translate?.message?.data?.loading || "Loading..."}
                                                            </button>
                                                        ) : (
                                                            <>
                                                                {currentQuestion?.length >= 6 ? (
                                                                    // Render the button without any action if the condition is met
                                                                    <>
                                                                        <button
                                                                            className="quiz-submit"
                                                                            style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                                            disabled
                                                                        >
                                                                            {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    // Render the button with the onClick handler for skipping
                                                                    <>
                                                                        <button
                                                                            className="quiz-submit"
                                                                            onClick={handleSkip}
                                                                            style={{ backgroundColor: "White" }}
                                                                        >
                                                                            {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <button className="quiz-submit" onClick={() => handleSubmit()}>
                                                            {Translate?.message?.data?.submit || "Submit"}
                                                        </button>
                                                    </div>
                                                </>
                                            )}


                                        </div>
                                    </div>


                                </div>

                            )}
                        </div>
                    </div>
                </div>
            </div>

            {isAiModalOpen && (
                <div className="help-ai-modal-overlay" onClick={closeAiModal}>
                    <div
                        className="help-ai-modal"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div className="help-ai-modal-header">
                            <h3>Help AI</h3>
                            <button className="help-ai-close-button" onClick={closeAiModal}>
                                ×
                            </button>
                        </div>
                        <div className="help-ai-modal-toolbar">
                            <button
                                className={`help-ai-toggle-button ${aiLanguage === "english" ? "active" : ""}`}
                                onClick={() => setAiLanguage("english")}
                                disabled={!currentQuestion?.ai_english_explain}
                            >
                                English
                            </button>
                            <button
                                className={`help-ai-toggle-button ${aiLanguage === "hindi" ? "active" : ""}`}
                                onClick={() => setAiLanguage("hindi")}
                                disabled={!currentQuestion?.ai_hindi_explain}
                            >
                                Hindi
                            </button>
                            <button
                                className="help-ai-sound-button"
                                onClick={() => {
                                    if (!currentQuestion) return;
                                    if (aiLanguage === "english") {
                                        speakText(currentQuestion.ai_english_explain, "en-US");
                                    } else {
                                        speakHindiExplainWithJapanese(currentQuestion.ai_hindi_explain);
                                    }
                                }}
                            >
                                <VolumeUpIcon />
                            </button>
                        </div>
                        <div className="help-ai-modal-body">
                            {aiLanguage === "english"
                                ? renderWithBold(
                                    currentQuestion?.ai_english_explain ||
                                    "No English explanation available."
                                )
                                : renderWithBold(
                                    currentQuestion?.ai_hindi_explain ||
                                    "No Hindi explanation available."
                                )}
                        </div>
                    </div>
                </div>
            )}
      <Footer />
    </div>
  );
}
export default TakeQuiz;
